/**
 * Hash listener
 */

const parseHashContent = (hash) => {
  const raw = (hash || "").replace(/^#/, "");
  let decoded = raw;
  try {
    decoded = utils.decodeURILocal(raw);
  } catch (e) {
    try {
      decoded = decodeURIComponent(raw.replace(/\+/g, " "));
    } catch (err) {
      decoded = raw;
    }
  }
  // Only "/?filter=" counts as hash query (slash right before ?).
  // Folder names like "Test ?filter=flop" must remain part of the path.
  const match = /\/\?filter=([^&]*)$/i.exec(decoded);
  if (!match) {
    return { path: decoded || "/", query: "" };
  }
  return {
    path: decoded.slice(0, match.index + 1) || "/",
    query: `filter=${match[1]}`,
  };
};

export default class HashListener {
  constructor({ onChange = () => {}, onInit = () => {} }) {
    this.init(onChange, onInit);
  }
  init = (onChange, onInit) => {
    var self = this;
    window.addEventListener("hashchange", () => {
      var h = this.getHash();
      if (h != self.hash) {
        self.hash = h;
        const { path } = parseHashContent(h);
        onChange(path, this.base64);
        this.base64 = null;
      }
    });
    if (this.getHash()) {
      const { path } = parseHashContent(this.getHash());
      onInit(path);
    }
  };
  setPath = (s, dir, base64) => {
    if (!s || typeof s !== "string") return;
    const extension = dir ? false : utils.getFileExtension(s);
    const path = extension ? s : s.endsWith("/") ? s : s + "/";

    if (base64) {
      this.base64 = base64;
    }

    document.location.hash = path;
    // if (document.location.hash != "#" + path)
    //   document.location.hash = utils.encodeURILocal(path); //fix for Firefox refusing some strings...umlauts
  };
  getPath = () => {
    const { path } = parseHashContent(this.getHash());
    return path || "/";
  };
  getHashQuery = () => {
    const { query } = parseHashContent(this.getHash());
    return query || "";
  };
  getHash = () => {
    return document.location.hash;
  };
  syncHash = () => {
    var s = this.hash;
    if (s != this.getHash()) {
      document.location.hash = s;
    }
  };
}
